<template>
  <div class="header" id="header">
    <div>
      <!--GNB-->
      <div class="gnb">
        <div class="wrapper_logo">
          <a :href="getUserUrl('home')" target="_blank">
            <i class="logo_nexon" />
          </a>
          <div class="line" />
          <router-link :to="{ path: `/${this.$i18n.locale}`, query: $route.query }">
            <span>{{ $t('gnb.name') }}</span>
          </router-link>
        </div>
        <div class="wrapper_controls">
          <div v-if="isLogin" class="login_area">
            <div class="outlink_faq" @click="openPopup()">
              <span>FAQ</span>
              <i class="icon_outlink_faq" />
            </div>
            <div class="line" />
            <!--krpc info menu-->
            <span v-if="userRegion === 'krpc'" class="krpc_info" @click="moveRouter('/userInfo')">{{
              $t('gnb.menu.withdrawInfo')
            }}</span>
            <!--jppc info menu-->
            <span v-if="userRegion === 'jppc'" class="jppc_info" @click="moveToNJAuth">{{
              $t('gnb.menu.userAuth')
            }}</span>
          </div>
          <div v-if="pointThumbnailList.length" class="point" @click="togglePointMenu">
            <button class="button_point">
              <span>{{ $t('gnb.menu.point') }}</span>
              <i class="icon_chevron_close" :class="{ open: isPointMenuOpen }" />
            </button>
            <div v-if="isPointMenuOpen" class="wrapper_point_list">
              <ul v-for="(service, index) of pointThumbnailList" :key="index">
                <li class="game_title" @click="moveRouter(`/${service.pathKey}/pointHistory`)">
                  <img :src="service.thumbnailImageUrl" alt="" />{{ getPointName(service.rpId) }}
                </li>
              </ul>
            </div>
          </div>
          <button v-if="!isLogin" class="button_login" @click="changeAccountState">{{ $t('gnb.login') }}</button>
          <button v-if="isLogin" class="button_logout" @click="changeAccountState">{{ $t('gnb.logout') }}</button>
        </div>
        <i :class="{ icon_menu: isLogin, none: !isLogin }" @click="toggleMobileMenu(true)" />
      </div>

      <!--FNB-->
      <div v-if="serviceInfo && showFnb" class="fnb" id="navigation">
        <div class="wrapper_menu">
          <div class="wrapper_service">
            <img :src="serviceInfo.thumbnailImageUrl" width="35" height="35" alt="" />
            <span>{{ serviceInfo.serviceName }}</span>
          </div>
          <ul class="menu_list">
            <li v-for="(el, idx) in navigation" :key="idx">
              <router-link
                :to="{ path: `/${getNeededLanguage()}/${serviceInfo.pathKey}/${el.path}`, query: { ...$route.query } }"
                :obj="`Menu_${el.path}`"
                :opt="`{&quot;servicename&quot;:&quot;${serviceInfo.pathKey}&quot;}`"
                @click.native="handleA2S"
              >
                {{ el.name }}
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!--lnb-->
    <div v-if="isMobileMenuOpen" class="layer_menu">
      <div class="area_menu">
        <i class="icon_close" @click="toggleMobileMenu(false)" />
        <div class="lnb_controls">
          <span v-if="userRegion === 'jppc'" class="jppc_info" @click="moveToNJAuth">{{
            $t('gnb.menu.userAuth')
          }}</span>
          <div v-if="pointThumbnailList.length" class="point">
            <div class="wrapper_text" @click="togglePointMenu">
              <span>{{ $t('gnb.menu.point') }}</span>
              <i class="icon_chevron_close" :class="{ open: isPointMenuOpen }" />
            </div>
            <div v-if="isPointMenuOpen" class="wrapper_point_list">
              <ul v-for="(service, index) of pointThumbnailList" :key="index">
                <li class="game_title" @click="moveRouter(`/${service.pathKey}/pointHistory`)">
                  <img :src="service.thumbnailImageUrl" alt="" />{{ getPointName(service.rpId) }}
                </li>
              </ul>
            </div>
          </div>
          <div v-if="isLogin" class="login_area">
            <span v-if="userRegion === 'krpc'" @click="moveRouter('/userInfo')">{{ $t('gnb.menu.withdrawInfo') }}</span>
            <div class="wrapper_text" @click="openPopup()">
              <span>FAQ</span>
              <i class="icon_outlink_faq" />
            </div>
          </div>
        </div>
        <div class="lnb_buttons" @click="changeAccountState">
          <p v-if="!isLogin" class="login_text">{{ $t('gnb.login') }}</p>
          <p v-if="isLogin" class="logout_text">{{ $t('gnb.logout') }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import sendLog from '@/utils/analistic';
import { isMobile, isLogin, goToLoginPage, logout, loginModal, checkUserRegion, checkArenaRegion } from '@/utils';
import { HOME_URL, FAQ_URL, NJ_OTP_URL } from '@/utils/variables';
import { getNeededLanguage } from '@/utils/lang';
import { CONTAINED_FNB_ROUTE_NAME_LIST } from '@/consts/consts';
import { authNJApi } from '@/api';
import { authNJErrorMsg } from '@/utils/errorMsg';

export default {
  data() {
    return {
      isMobileMenuOpen: false,
      isPointMenuOpen: false,
    };
  },
  computed: {
    ...mapGetters(['pointThumbnailList', 'pointList', 'serviceInfo', 'serviceUrl']),
    isLogin() {
      return isLogin();
    },
    userRegion() {
      return checkUserRegion();
    },
    navigation() {
      return [
        {
          path: 'pointHistory',
          name: this.$i18n.t('fnb.menu.pointHistory'),
        },
        {
          path: 'exchangeHistory',
          name: this.$i18n.t('fnb.menu.pointExchangeHistory'),
        },
      ];
    },
    showFnb() {
      return CONTAINED_FNB_ROUTE_NAME_LIST.includes(this.$route.name);
    },
  },
  watch: {
    $route(to, from) {
      if (to.path !== from.path) {
        this.isMobileMenuOpen = false;
      }
    },
  },
  methods: {
    ...mapActions('modal', ['openModal']),
    ...mapActions('userInfo', ['checkOTP']),
    getPointName(id) {
      const idx = this.pointList.findIndex((point) => point.rpId === id);
      return this.pointList[idx].pointName;
    },
    moveRouter(path) {
      this.toggleMobileMenu(false);
      if (!isLogin()) {
        loginModal(path);
      } else {
        this.$router.push({
          path: `/${this.$i18n.locale}${path}`,
          query: { ...this.$route.query },
        });
      }
    },
    async moveToNJAuth() {
      const { data } = await authNJApi.checkOTP();
      if (data?.code === -1 || data?.code === 10000) {
        this.openModal(authNJErrorMsg(data?.message));
        return;
      }

      const hasOTP = data.data?.registered;
      if (!hasOTP) {
        this.openModal({
          type: 'confirm',
          message: this.$t('global.otpGuide'),
          callback: () => {
            window.open(NJ_OTP_URL, '_blank');
          },
        });
        return;
      }
      this.checkOTP(hasOTP);
      this.moveRouter('/auth');
    },
    getNeededLanguage() {
      return getNeededLanguage();
    },
    getUserUrl(type) {
      if (type === 'home') {
        if (this.userRegion === 'arena') {
          return HOME_URL[`${this.userRegion}_${checkArenaRegion()}`];
        }
        return HOME_URL[this.userRegion] || HOME_URL.default;
      }
      if (type === 'faq') {
        return FAQ_URL[this.userRegion][this.$i18n.locale] || FAQ_URL.arena[this.$i18n.locale];
      }
    },
    openPopup() {
      const url = this.getUserUrl('faq');
      const features = !isMobile ? 'width=1280, height=1024' : '';
      window.open(url, '_blank', features);
    },
    toggleMobileMenu(val) {
      if (val) {
        this.isMobileMenuOpen = true;
        this.isPointMenuOpen = false;
        this.$emit('prevent-scroll', true);
      } else {
        this.isMobileMenuOpen = false;
        this.$emit('prevent-scroll', false);
      }
    },
    togglePointMenu() {
      this.isPointMenuOpen ? (this.isPointMenuOpen = false) : (this.isPointMenuOpen = true);
    },
    changeAccountState() {
      !this.isLogin ? goToLoginPage() : logout();
    },
    handleA2S(e) {
      const { obj, opt } = e.target.attributes;
      if (obj && opt) {
        sendLog(e.target.attributes.obj.value, JSON.parse(e.target.attributes.opt.value));
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  position: sticky;
  top: 0;
  padding: 0;
  font-family: 'NEXONLv1Gothic';
}

.gnb {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #fff;
  padding: 18px 30px;
}
.icon_menu {
  display: none;
}
.wrapper_logo {
  display: flex;
  align-items: center;
  height: 24px;
  .logo_nexon {
    background: url('~@/assets/images/img_nexonlogo.svg') no-repeat 0 0;
    display: block;
    background-size: contain;
    width: 84px;
    height: 12px;
  }
  .line {
    width: 1px;
    height: 11px;
    background: #eee;
    opacity: 0.4;
    margin: 0 15px;
  }
  span {
    font-weight: 700;
    font-size: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
  }
}
.wrapper_controls {
  display: flex;
  align-items: center;
  font-weight: 400;
  font-size: 14px;
  line-height: 14px;
  .login_area {
    display: flex;
  }
  .krpc_info,
  .jppc_info {
    margin-right: 30px;
  }
  span {
    color: #fff;
    &:hover {
      cursor: pointer;
      color: #ffeb00;
    }
  }
  .point {
    .button_point {
      display: flex;
      align-items: center;
      position: relative;
      background: transparent;
      &:hover {
        cursor: pointer;
        color: #ffeb00;
        > span {
          color: #ffeb00;
        }
        .icon_chevron_close {
          background: url('~@/assets/images/icon_chevron_hover.svg') no-repeat 0 0;
          display: block;
          background-size: contain;
          width: 10px;
          height: 7px;
        }
      }
      .icon_chevron_close {
        margin-left: 5px;
        background: url('~@/assets/images/icon_chevron.svg') no-repeat 0 0;
        display: block;
        background-size: contain;
        width: 10px;
        height: 7px;
        &.open {
          transform: rotate(180deg);
          margin-bottom: 3px;
        }
      }
    }
    .wrapper_point_list {
      min-width: 210px;
      max-height: calc(100vh - 60px);
      display: flex;
      flex-direction: column;
      position: absolute;
      top: 52px;
      right: 74px;
      overflow: auto;
      z-index: 50;
      background: #fff;
      border: 1px solid #eee;
      box-shadow: 0 0 7px rgba(0, 0, 0, 0.15);
      border-radius: 8px;
      ul {
        display: flex;
        flex-direction: column;
        gap: 12px;
      }
      li {
        height: 18px;
        margin: 0;
        padding: 0 13px;
        font-weight: 400;
        font-size: 14px;
        line-height: 18px;
        color: #666666;
        text-align: left;
        cursor: pointer;
        &:first-child {
          border-top-left-radius: 8px;
          border-top-right-radius: 8px;
        }
        &:last-child {
          border-bottom-left-radius: 8px;
          border-bottom-right-radius: 8px;
        }
        img {
          width: 23px;
          height: 23px;
        }
      }
      .sub_menu {
        cursor: pointer;
        font-family: 'Malgun Gothic', Arial, sans-serif;
        &:hover {
          color: #111;
        }
      }
      .game_title {
        display: flex;
        height: 48px;
        align-items: center;
        overflow: hidden;
        padding: 0 13px;
        font-weight: 700;
        font-size: 13px;
        line-height: 20px;
        color: #111;
        > img {
          border-radius: 50%;
          margin-right: 8px;
          width: 24px;
          height: 24px;
        }
      }
    }
  }
  .line {
    width: 1px;
    height: 12px;
    background: #e4e4e4;
    opacity: 0.3;
    margin: 0 25px;
  }
  .outlink_faq {
    display: flex;
    align-items: center;
    .icon_outlink_faq {
      margin-left: 5px;
      background: url('~@/assets/images/icon_outlink.svg') no-repeat 0 0;
      display: block;
      background-size: contain;
      width: 12px;
      height: 12px;
    }
    &:hover {
      cursor: pointer;
      color: #ffeb00;
      > span {
        color: #ffeb00;
      }
      .icon_outlink_faq {
        background: url('~@/assets/images/icon_outlink_hover.svg') no-repeat 0 0;
        display: block;
        background-size: contain;
        width: 12px;
        height: 12px;
      }
    }
  }
}
.none {
  display: none;
}
.button_login {
  width: 71px;
  height: 34px;
  margin-left: 40px;
  border: 1px solid #fff;
  border-radius: 500px;
  background: #050c42;
  color: #fff;
  font-weight: 700;
  font-size: 13px;
  line-height: 13px;
  &:hover {
    background: #ffeb00;
    border: 1px solid #ffc400;
    color: #10100a;
  }
}
.button_logout {
  //width: 84px;
  height: 34px;
  margin-left: 40px;
  padding: 11px 17px 10px 17px;
  color: #fff;
  font-weight: 700;
  font-size: 13px;
  line-height: 13px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 500px;
}

.fnb {
  height: 69px;
  padding: 0 30px;
  background: #fdfdfd;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.07);
  ul {
    flex: none;
    padding: 0;
    li {
      a {
        &:active {
          font-weight: 700;
          color: #111;
        }
      }
    }
  }
  span {
    font-weight: 700;
    font-size: 18px;
    line-height: 18px;
    color: #111;
  }
}
.wrapper_menu {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  max-width: 960px;
  width: 100%;
  margin: 0 auto;
}
.wrapper_service {
  display: flex;
  align-items: center;
  img {
    margin-right: 10px;
    border-radius: 50%;
  }
}
.menu_list {
  display: flex;
  gap: 55px;
  height: 69px;
  justify-content: center;
  a {
    display: flex;
    align-items: center;
    height: 69px;
    white-space: nowrap;
    border-bottom: 4px solid transparent;
    font-weight: 400;
    font-size: 16px;
    line-height: 15px;
    text-align: center;
    color: #111;
    &.router-link-exact-active {
      font-weight: 700;
      border-color: #ffeb00;
    }
  }
}
.layer_menu {
  display: none;
}

@media all and (max-width: 767px) {
  .fnb {
    padding: 0 15px;
  }
  .icon_menu {
    display: block;
    background: url('~@/assets/images/icon_menu.svg') no-repeat 0 0;
    background-size: contain;
    width: 26px;
    height: 26px;
    &:hover {
      background: url('~@/assets/images/icon_menu_hover.svg') no-repeat 0 0;
      background-size: contain;
      width: 26px;
      height: 26px;
      cursor: pointer;
    }
  }
  @media (hover: none) {
    .icon_menu:hover {
      background: url('~@/assets/images/icon_menu.svg') no-repeat 0 0;
    }
  }
  .wrapper_controls {
    .login_area,
    .point,
    .button_logout {
      display: none;
    }
  }
  .wrapper_menu {
    max-width: 767px;
  }
  .wrapper_service {
    span {
      display: none;
    }
  }
  .menu_list {
    margin-left: auto;
  }
  .layer_menu {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 20;
    font-family: 'NEXONLv1Gothic';
    .area_menu {
      display: flex;
      top: 0;
      right: 0;
      width: 330px;
      height: 100%;
      background: #fff;
    }
    .icon_close {
      display: block;
      position: absolute;
      top: 17px;
      right: 17px;
      background: url('~@/assets/images/icon_close.svg') no-repeat 0 0;
      background-size: contain;
      width: 26px;
      height: 26px;
      cursor: pointer;
    }
    .lnb_controls {
      display: flex;
      flex-direction: column;
      gap: 50px;
      width: 100%;
      height: calc(100% - 160px);
      margin: 80px 30px 0 30px;
      overflow-y: auto;
      .login_area {
        display: flex;
        flex-direction: column;
        gap: 50px;
      }
      span {
        font-weight: 700;
        font-size: 26px;
        line-height: 26px;
        color: #111;
        cursor: pointer;
      }
      .wrapper_text {
        display: flex;
        align-items: center;
        cursor: pointer;
      }
      .icon_chevron_close {
        display: block;
        margin-left: 10px;
        background: url('~@/assets/images/icon_chevron_black.svg') no-repeat 0 0;
        background-size: contain;
        width: 20px;
        height: 13px;
        &.open {
          transform: rotate(180deg);
          margin-bottom: 3px;
        }
      }
      .icon_outlink_faq {
        display: block;
        margin-left: 10px;
        background: url('~@/assets/images/icon_outlink_black.svg') no-repeat 0 0;
        background-size: contain;
        width: 20px;
        height: 20px;
      }
      .wrapper_point_list {
        margin-top: 25px;
        ul {
          display: flex;
          flex-direction: column;
          gap: 10px;
          margin-bottom: 25px;
        }
        .sub_menu {
          font-weight: 400;
          font-size: 14px;
          line-height: 18px;
          color: #666;
          margin: 10px 0 0 44px;
          cursor: pointer;
          font-family: 'Malgun Gothic', Arial, sans-serif;
        }
      }
      .game_title {
        display: flex;
        align-items: center;
        font-weight: 700;
        font-size: 18px;
        line-height: 26px;
        color: #111;
        cursor: pointer;
        img {
          border-radius: 50%;
          margin-right: 12px;
          width: 36px;
          height: 36px;
        }
      }
    }
    .lnb_buttons {
      position: fixed;
      bottom: 0;
      width: 330px;
      height: 60px;
      display: flex;
      justify-content: center;
      align-items: center;
      background: #000;
      cursor: pointer;
      p {
        color: #fff;
        font-weight: 700;
        font-size: 16px;
        line-height: 16px;
      }
      .logout_text {
        opacity: 0.6;
      }
      &:hover {
        .login_text {
          color: #ffeb00;
        }
        .logout_text {
          color: #fff;
          opacity: 1;
        }
      }
    }
  }
}

@media all and (max-width: 479px) {
  .gnb {
    padding: 18px 15px;
  }
  .fnb {
    height: 52px;
  }
  .icon_menu {
    width: 24px;
    height: 24px;
    &:hover {
      width: 24px;
      height: 24px;
    }
  }
  .wrapper_menu {
    max-width: 480px;
  }
  .wrapper_service {
    span {
      display: none;
    }
    img {
      width: 30px;
      height: 30px;
      margin-right: 0;
    }
  }
  .menu_list {
    height: 52px;
    gap: 26px;
    a {
      height: 52px;
      font-size: 13px;
      line-height: 13px;
    }
  }
  .layer_menu {
    .lnb_controls {
      line-height: 22px;
      gap: 40px;
      margin: 60px 60px 0 30px;
      .login_area {
        gap: 40px;
      }
      .wrapper_point_list {
        margin-top: 20px;
        ul {
          margin-bottom: 20px;
        }
        .sub_menu {
          font-size: 12px;
          line-height: 12px;
          margin: 10px 0 0 31px;
        }
      }
      .game_title {
        font-size: 16px;
        line-height: 24px;
        img {
          border-radius: 50%;
          margin-right: 8px;
          width: 32px;
          height: 32px;
        }
      }
      span {
        font-size: 22px;
        line-height: 22px;
      }
    }
  }
}

@media all and (max-width: 360px) {
  .fnb {
    height: 46px;
  }
  .wrapper_menu {
    max-width: 320px;
  }
  .wrapper_logo {
    span {
      letter-spacing: -1.5px;
      font-size: 14px;
    }
  }
  .wrapper_controls {
    .button_login {
      width: 60px;
    }
  }
  .menu_list {
    height: 46px;
    .sub_menu {
      height: 46px;
    }
  }
  .layer_menu {
    .icon_close {
      top: 10px;
      right: 3px;
    }
    .lnb_controls {
      gap: 26px;
      margin: 35px 15px 0 15px;
      .login_area {
        gap: 26px;
      }
      .wrapper_point_list {
        margin-top: 16px;
      }
      span {
        font-size: 16px;
        line-height: 16px;
      }
      .game_title {
        font-size: 13px;
        line-height: 20px;
        img {
          width: 23px;
          height: 23px;
        }
      }
      .icon_chevron_close {
        width: 10px;
        height: 7px;
      }
      .icon_outlink_faq {
        width: 14px;
        height: 14px;
      }
    }
    .area_menu,
    .lnb_buttons {
      width: 260px;
    }
    .icon_close {
      background: url('~@/assets/images/icon_close.svg') no-repeat 0 0;
      background-size: contain;
      width: 24px;
      height: 24px;
      cursor: pointer;
    }
  }
}
</style>
